import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const UpdateRangeForm = () => {
  const [errors, setErrors] = useState({})
  const [rateOptions, setRateOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
    from_range: "0",
    to_range: "0",
    price: "0",
    base: null,
    base_price: null,
    rate_id: "",
    public_id: ''
  })
  const {from_range, to_range, price, base, base_price, rate_id, public_id} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {range} = location.state
        setFormData({
            from_range: range.from_range,
            to_range: range.to_range,
            price: range.price,
            base: range.base,
            base_price: range.base_price,
            rate_id: range.rate_id,
            public_id: range.public_id
        })
    }


  }, [location]);

  const loadOptions = async (url, query, setOptions) => {
        const params = { q: query };
        try {
            const response = await Server.get(`/options/${url}`, {params});
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    }; 
  

  const onChange = (e) => {
      setFormData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value
      }))
  }

  const onSubmit = (e) => {
      e.preventDefault()

      const payload = {from_range, to_range, price, base, base_price, rate_id}
          updateRange(payload)
  }
  
  // update range
  const updateRange = async (payload) => {
      setIsLoading(true)
      try {
          const response = await Server.put(`/ranges/${public_id}`, payload)
          if (response.status === 200){
              navigate('/ranges')
              setIsLoading(false)
              toast.success('Successfully updated')
          }else{
              toast.error(response.data?.detail)
          }
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422) {
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
            toast.error(error.response.data.detail);
            navigate('/');
        }else {
            toast.error(error.response.data.detail);
        }
      }
  }

  if(isLoading){
      return <Spinner/>
  }

return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Range Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="rate_id"
                                label="Rate"
                                value={rate_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('rates', query, setRateOptions)}
                                options={rateOptions}
                                placeholder="Start typing to search..."
                                error={errors.rate_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="From Range"
                                name="from_range"
                                type="text"
                                label="From"
                                value={from_range}
                                onChange={onChange}
                                error={errors.from_range}
                            />
                        </div>

                        <div className="col-md-4">
                            <InputField
                                placeholder="To Range"
                                name="to_range"
                                type="number"
                                label="To"
                                value={to_range}
                                onChange={onChange}
                                error={errors.to_range}
                            />
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-4">
                            <InputField
                                placeholder="Price"
                                name="price"
                                type="text"
                                label="Price"
                                value={price}
                                onChange={onChange}
                                error={errors.price}
                            />
                        </div> 
                        <div className="col-md-4">
                            <InputField
                                placeholder="Base (Optional)"
                                name="base"
                                type="text"
                                label="Base"
                                value={base}
                                onChange={onChange}
                                error={errors.base}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Base Price (Optional)"
                                name="base_price"
                                type="text"
                                label="Base Price"
                                value={base_price}
                                onChange={onChange}
                                error={errors.base_price}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Range" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default UpdateRangeForm
